// 1. 监听error事件，从中获取script link标签的资源加载错误
// 2. 获取错误的src，发送一个HEAD请求，获取此次请求的状态码
// 3. 如资源状态码是404，则将此次resouceError信息上报至Sentry或其他监控平台，触发预警

const fetchResourceHTTPStatus = (src: string) => {
  return new Promise(resolve => {
    const xhr = new XMLHttpRequest()
    xhr.open("HEAD", src)
    xhr.onload = function() {
      resolve(xhr.status)
    }
    xhr.send()
  })
}

const recordResourceError = (reportFn: (result: any) => void) => {
  window.addEventListener(
    "error",
    function(e) {
      const target = e.target as HTMLElement
      const tagName = target.localName
      let sourceUrl = ""
      if (tagName === "link") {
        sourceUrl = (target as HTMLLinkElement).href
      } else if (tagName === "script") {
        sourceUrl = (target as HTMLScriptElement).src
      }
      sourceUrl &&
        fetchResourceHTTPStatus(sourceUrl).then(status =>
          reportFn({
            src: sourceUrl,
            status,
          }),
        )
    },
    true,
  )
}

// 上报资源404错误
const resourceErrorReporter = ({
  src,
  status,
}: {
  src: string
  status: number
}) => {
  if (status !== 404) {
    return
  }
  const errorMessage = `[${status}]: ${src}`
  // 同时上报Sentry / Arms
  window.Sentry && window.Sentry.captureException(new Error(errorMessage))
}

export const initResouceErrorLisenter = () => {
  recordResourceError(resourceErrorReporter)
}
